// 상세 사진 0장 처리 — 의존성 없는 순수 함수(시험: __tests__/detailImageZero.test.mjs).
// 1688 에서 상세 사진을 하나도 못 가져온 상품은 상세이미지 작업이 만들 것이 없다. 예전엔 'completed' 만 돌려주고
// 상태를 아무도 안 써서 'processing' 에 영구히 머물렀고, 견적서는 상세이미지·대체텍스트 칸이 비어 멈췄다(PR261017-305255).

export const DETAIL_IMAGE_ZERO_MESSAGE = '1688 상세 사진 0장 — 상세이미지 재료 없음'

// 상세 사진이 없으면 작업 결과(error)를, 있으면 null 을 돌려준다
export function zeroDetailImageResult(product) {
  const list = (product && product.detailImages) || []
  if (list.length > 0) return null
  return { status: 'error', error: DETAIL_IMAGE_ZERO_MESSAGE, type: 'detailImageStatus', processedImages: [] }
}

// 상세이미지가 error 일 때 그 이유 한 줄 — runWork·startQueue 결과의 reason 에 붙인다
export function detailImageErrorText(product) {
  if (!product) return undefined
  const s = product.detailImageStatus
  const status = s && typeof s === 'object' ? s.status : s
  if (status !== 'error') return undefined
  const w = product.detailImageWarning
  return (w && typeof w === 'object' && w.message) ? String(w.message).slice(0, 300) : undefined
}
